/*
 * tokenrom.js -- GENERATED. Do not edit.
 *
 *   built by tools/build-token-rom.mjs from token.s
 *   147 bytes of 6502, padded to a 256-byte slot ROM page
 *
 * Firmware for the TCS-2400, mapped at $C200 when the card is in slot 2.
 * Entry points:
 *
 *   $C200  advance the session token by the byte in A, then transmit it
 *   $C203  the same for a null-terminated string at A/Y
 *
 * This is the card's driver. Peripherals carried their drivers in ROM,
 * which is why there is nothing on the disk to find and nothing for
 * DOS to load.
 */

export const TOKEN_ROM = new Uint8Array([
  0x4c, 0x06, 0xc2, 0x4c, 0x7c, 0xc2, 0x29, 0x7f, 0x85, 0xef, 0x8a, 0x48,
  0x98, 0x48, 0xad, 0xa4, 0xc0, 0x85, 0xeb, 0xad, 0xa5, 0xc0, 0x85, 0xec,
  0xad, 0xa6, 0xc0, 0x85, 0xed, 0xad, 0xa7, 0xc0, 0x85, 0xee, 0xa5, 0xeb,
  0x45, 0xef, 0x85, 0xeb, 0xa2, 0x08, 0x06, 0xeb, 0x26, 0xec, 0x26, 0xed,
  0x26, 0xee, 0x90, 0x0c, 0xa5, 0xeb, 0x49, 0x07, 0x85, 0xeb, 0xa5, 0xed,
  0x49, 0x40, 0x85, 0xed, 0xca, 0xd0, 0xe7, 0x18, 0xa5, 0xeb, 0x65, 0xee,
  0xa8, 0xa5, 0xec, 0x65, 0xeb, 0x48, 0xa5, 0xed, 0x65, 0xec, 0xaa, 0xa5,
  0xee, 0x65, 0xed, 0x8d, 0xa7, 0xc0, 0x8e, 0xa6, 0xc0, 0x68, 0x8d, 0xa5,
  0xc0, 0x8c, 0xa4, 0xc0, 0xa5, 0xef, 0xa0, 0x00, 0x2c, 0xa1, 0xc0, 0x70,
  0x05, 0x88, 0xd0, 0xf8, 0xf0, 0x03, 0x8d, 0xa0, 0xc0, 0x68, 0xa8, 0x68,
  0xaa, 0xa5, 0xef, 0x60, 0x85, 0xeb, 0x84, 0xec, 0xa0, 0x00, 0xb1, 0xeb,
  0xf0, 0x0c, 0x29, 0x7f, 0x84, 0xf0, 0x20, 0x06, 0xc2, 0xa4, 0xf0, 0xc8,
  0xd0, 0xf0, 0x60, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
  0xff, 0xff, 0xff, 0xff,
]);
